import {
  getRolesList,
  getStudioMembersHasPermission,
  getUserGroupsList,
} from '../../../api';
import { RbacRoleObjectKey } from '../../../model';
import { RoleType } from '../../../model/api-modules';
import { store } from '../../../store';

// return false 代表可以使用任意游戏/环境
export const queryAnyEnvWithOperationPerm = async (studioID: string) => {
  const userID = store.getState().common.userInfo?.UserID;
  const members = await getStudioMembersHasPermission(studioID);
  if (!members || !userID) {
    return false;
  }

  const matchedMember = members.find((item) => item.UserID === userID);
  if (!matchedMember) {
    return false;
  }

  const isAdmin = matchedMember.RbacMember.some((item) =>
    [RoleType.Owner, RoleType.Admin].includes(item.roleType)
  );
  if (isAdmin) {
    return false;
  }
  if (!matchedMember.RbacMember.length) {
    return false;
  }

  const defaultGroups = ['Editor Group', 'Viewer Group'];
  const isEditorViewerGroup = matchedMember.RbacMember.some((item) =>
    defaultGroups.includes(item.groupName || '')
  );

  if (isEditorViewerGroup) {
    return false;
  }

  const otherGroups = matchedMember.RbacMember.filter(
    (item) => !defaultGroups.includes(item.groupName || '')
  ).map((item) => item.groupId);

  if (!otherGroups.length) {
    return false;
  }

  const allGroups = await getUserGroupsList(studioID);
  const allRoles = await getRolesList(studioID);
  if (!allGroups || !allRoles) {
    return false;
  }

  let matchGameEnv: {
    game?: 'all' | string;
    env?: 'all' | number;
  } = {};

  for (const groupId of otherGroups) {
    const matchedGroup = allGroups.find((item) => item.groupId === groupId);
    if (!matchedGroup) {
      continue;
    }

    for (const groupRole of matchedGroup.roles) {
      const matchedRole = allRoles.find(
        (item) => item.roleId === groupRole.roleId
      );

      if (
        matchedRole?.permissions.includes(RbacRoleObjectKey.OperationReportView)
      ) {
        matchGameEnv = {
          game: groupRole.scope === 0 ? 'all' : groupRole.scope[0]?.gameId,
          env:
            groupRole.scope &&
            (groupRole.scope[0]?.envId === 0
              ? 'all'
              : groupRole.scope[0]?.envId?.[0]),
        };
        break;
      }
      continue;
    }
  }

  if (matchGameEnv.game === 'all') {
    return false;
  }

  if (matchGameEnv.game && matchGameEnv.env) {
    return {
      game: matchGameEnv.game,
      env: matchGameEnv.env === 'all' ? 0 : matchGameEnv.env,
    };
  }

  return false;
};
